import { createQueryKeys } from '@lukemorales/query-key-factory';

import { aimsApi } from '@/axios/AclosetApi';

export const 코너로지스_고객정보_쿼리 = createQueryKeys('corner-logis-customer-info', {
  고객정보_조회: ({ shopID }: { shopID: string }) => ({
    queryKey: [shopID] as const,
    queryFn: () => aimsApi.shops.cornerLogisCustomerList(shopID).then(v => v.data),
  }),
});
